import React, { Component } from 'react'
import { connect } from 'react-redux'
import CryptoJS from 'crypto-js'
import isAuthenticated from '../../routes/isAuthenticated'
import { Card, Container, Row, Accordion, Col, Form, Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import CircularProgress from '@material-ui/core/CircularProgress'
import BootstrapTable from 'react-bootstrap-table-next'
import moment from 'moment'
import ActionData from '../../types/ActionData'
import Resource from '../../types/Resource'
import User from '../../types/User'
import { addUserActivity } from '../../redux/actions/authentication'
import { getResources } from '../../redux/actions/resource'
import DatePicker from 'react-datepicker'
import { formatUTCDate } from '../../utils/stringTools'
import { getUniqueValsFromArrayOfObjs } from '../../utils/dataTools'
import { getDomainName } from '../../utils/envVariables'
import './index.css'

interface Props {
  height: number;
  width: number;
  resources: Array<Resource>;
  resourcesResult: ActionData;
  user: User;
  addUserActivity: (data: { eid: string; activity: string; memberId?: number; organizationId?: number; providerId?: number }, token: string ) => void;
  getResources: (token: string) => void;
}

class Resources extends Component<Props> {
  state = {
    searchOpen: false,
    startDate: undefined,
    endDate: undefined,
    category: 'All',
    fileFormat: 'All',
    title: '',
    filteredResults: [],
    filterSet: false
  }

  componentDidMount() {
    const { user, addUserActivity, getResources } = this.props
    const emailKey = 'lakelandproviderportalinsertuserencryption'
    const email = user.isLakeland ? { eid: CryptoJS.AES.encrypt(user.email, emailKey).toString() } : JSON.parse(localStorage.getItem('p_sid')|| '{}')

    let token
    if(localStorage.getItem('token')!== null && localStorage.getItem('token')!=='undefined'){
    	token = JSON.parse(localStorage.getItem('token')|| '')
      getResources(token)

      addUserActivity({
        eid: email.eid,
        activity: 'View Resources',
      }, token)
    }
  }

  componentDidUpdate(prevProps: Props) {
    const { user, getResources } = this.props

    if (user !== prevProps.user && user.organization_id!==undefined) {
      let token
      if (localStorage.getItem('token')!== null) {
        token = JSON.parse(localStorage.getItem('token')|| '')
      }

      getResources(token)
    }
  }

  applyFilters = (data: Array<Resource>) => {
    const { startDate, endDate, category, fileFormat, title } = this.state
		
    let filteredResults = data
	
    if (startDate !== undefined) {
		  filteredResults = filteredResults.filter((result) => moment.utc(startDate).isSameOrBefore(moment.utc(result.date)))
    }
	
    if (endDate !== undefined) {
		  filteredResults = filteredResults.filter((result) => moment.utc(endDate).isSameOrAfter(moment.utc(result.date)))
    }
	
    if (category !== 'All') {
		  filteredResults = filteredResults.filter((result) => result.category === category)
    }
	
    if (fileFormat !== 'All') {
		  filteredResults = filteredResults.filter((result) => result.fileFormat === fileFormat)
    }
	
    if (title !== '') {
		  filteredResults = filteredResults.filter((result) => result.title === title)
    }
	
    this.setState({
		  filteredResults,
		  filterSet: true
    })
  }

  clearFilters = () => {
    this.setState({ startDate: undefined, endDate: undefined, category: 'All', fileFormat: 'All', title: '', filterSet: false, filteredResults: []})
  }

  handleSearchIconClicked = () => {
    this.setState({
      searchOpen : !this.state.searchOpen
    })
  }
	
  handleChangeStart = (date: Date) => {
    this.setState({
      startDate: date
    })
  }

  handleChangeEnd = (date: Date) => {
    this.setState({
      endDate: date
    })
  }
	
  handleChangeString = (evt: any) => {
    this.setState({ [evt.target.name]: evt.target.value })
  }

  render() {
    const { height, width, resources, resourcesResult } = this.props
    const { startDate, endDate, category, fileFormat, title, filterSet, filteredResults } = this.state
    const domainName = getDomainName()

    const diff = moment.utc().diff(moment.utc(resources[0] ? resources[0].date : undefined), 'days')
    let updatedString
    if (diff === 1) {
      updatedString = `${diff} day ago on ${resources[0] ? formatUTCDate(resources[0].date) : ''}`
    } else {
      updatedString = `${diff} days ago on ${resources[0] ? formatUTCDate(resources[0].date) : ''}`
    }
    const columns = [{
      dataField: 'date',
      text: 'Date Added/Updated',
      sort: true,
      formatter: formatUTCDate
    }, {
      dataField: 'file_location',
      text: 'File Name',
      sort: true,
      headerStyle: {
        width: 400
      },
      formatter: (cell) => {
        let content = cell.split('/')
        return (
          <Link
            to="route"
            onClick={(event) => { event.preventDefault(); window.open(domainName+'/pdf/resources/'+content[content.length-1]) }}
          >
            {content[content.length-1]}
          </Link>
        )
      }
    }, {
      dataField: 'category',
      text: 'Category',
      sort: true
    }
    ]
    const uniqueFormats = getUniqueValsFromArrayOfObjs(resources, 'fileFormat')
	
    let data =  <div>No Resources available</div>
	
    if(resourcesResult.loading===true)
      data = (
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '20px'}}>
          <CircularProgress size={40} />
          <span>Loading data</span>
        </div>
      )

    return (
      <Container 
        style={{
          paddingLeft: 0,
          paddingTop:20, 
          backgroundColor: '#f5f5f5', 
          width:width, 
          height:height-20, 
          maxWidth:width, 
          overflow:'auto'
        }}
      >
        <Row>
          <div className="resource-header">
            <div className="resource-header-txt">
              <div className="resource-icon">
                <FontAwesomeIcon icon={['fas', 'file-alt']} size="3x" />
              </div>
              <div>
                <div className="resource-container">
                  <h3>Resources</h3>
                </div>
                <div className="resource-data">
                  <div>Last Updated: { updatedString } </div>
                </div>
              </div>
            </div>
          </div>
        </Row>
        <Card style={{ border: 'none', width: width, height: height - 120 }}>
          <Card.Body>
            <div className="resource-container">
              <Accordion style={{ marginBottom: 20, borderBottom: '1px solid rgba(0, 0, 0, 0.125)', width: '98%' }}>
                <Card>
                  <Card.Header>
                    <Row>
                      <Col xs={10}>
												Search Resources
                      </Col>
                      <Accordion.Toggle as={Col} eventKey="0" onClick={this.handleSearchIconClicked}>
                        {
                          this.state.searchOpen
                            ? (
                              <div onClick={this.handleSearchIconClicked}>
                                <FontAwesomeIcon icon={['fas', 'caret-up']} size="lg" style={{ fontSize: '2rem', marginTop: -5, float: 'right' }} />
                              </div>
                            )
                            : (
                              <div onClick={this.handleSearchIconClicked}>
                                <FontAwesomeIcon icon={['fas', 'caret-down']} size="lg" style={{ fontSize: '2rem', marginTop: -5, float: 'right' }} />
                              </div>
                            )
                        }
                      </Accordion.Toggle>
                    </Row>
                  </Card.Header>
                  <Accordion.Collapse eventKey="0">
                    <Card.Body>
                      <div>
                        <Row>
                          <Col xs={4}>
                            <Form.Group>
                              <Form.Label>Date Range</Form.Label>
                              <Row>
                                <Col xs={6}>
                                  <DatePicker
                                    dateFormat="M/d/yy"
                                    selected={startDate}
                                    selectsStart
                                    startDate={startDate}
                                    endDate={endDate}
                                    onChange={this.handleChangeStart}
                                    className="datepicker"
                                    placeholderText="Start Date"
                                  />
                                </Col>
                                <Col xs={6}>
                                  <DatePicker
                                    dateFormat="M/d/yy"
                                    selected={endDate}
                                    selectsEnd
                                    startDate={startDate}
                                    endDate={endDate}
                                    onChange={this.handleChangeEnd}
                                    minDate={startDate}
                                    className="datepicker"
                                    placeholderText="End Date"
                                  />
                                </Col>
                              </Row>
                            </Form.Group>
                          </Col>
                          <Col xs={4}>
                            <Form.Group>
                              <Form.Label>Category</Form.Label>
                              <Form.Control as="select" name="category" value={category} onChange={this.handleChangeString}>
                                <option value='All'>All</option>
                                <option value='General Communications'>General Communications</option>
                                <option value='Contract Addendums'>Contract Addendums</option>
                              </Form.Control>
                            </Form.Group>
                          </Col>
                          <Col xs={4}>
                            <Form.Group>
                              <Form.Label>File Format</Form.Label>
                              <Form.Control as="select" name="fileFormat" value={fileFormat} onChange={this.handleChangeString}>
                                <option value='All'>All</option>
                                {
                                  uniqueFormats.map((format) => <option value={format} key={format}>{ format.toUpperCase() }</option>)
                                }
                              </Form.Control>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={4}>
                            <Form.Group>
                              <Form.Label>Attachment Title</Form.Label>
                              <Form.Control
                                placeholder="Enter Attachment Title"
                                aria-label="Enter Attachment Title"
                                name="title"
                                value={title}
                                onChange={this.handleChangeString}
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={{ span: 1, offset: 10 }}>
                            <Button variant="outline-secondary" block onClick={this.clearFilters}>Clear</Button>
                          </Col>
                          <Col xs={1}>
                            <Button variant="success" block onClick={this.applyFilters.bind(this, resources)}>Search</Button>
                          </Col>
                        </Row>
                      </div>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              </Accordion>
            </div>
            <div style={{ width: '98%', marginTop: 10 }}>
              <BootstrapTable
                keyField='id'
                bootstrap4
                data={filterSet ? filteredResults : resources}
                columns={columns}
                striped
                condensed
                hover
                noDataIndication={() => (data)}
              />
            </div>
          </Card.Body>
        </Card>
      </Container>
    )
  }
}

const mapStateToProps = (state: any) => ({
  resources: state.resource.resources.data,
  resourcesResult: state.resource.resources,
  user: state.authentication.user.data
})

const mapDispatchToProps = (dispatch: any) => ({
  addUserActivity: (data: { eid: string; activity: string; memberId?: number; organizationId?: number; providerId?: number }, token: string ) => dispatch(addUserActivity(data, token)),
  getResources: (token: string) => dispatch(getResources(token))
})

export default isAuthenticated(
  connect(mapStateToProps, mapDispatchToProps)(Resources)
)